import { Button, ButtonBar } from "@/overlay/components/CommonParts/buttons";
import { Modal } from "@/overlay/components/window/Modal";
import styles from "./SavedColorsCloseConfirmationModal.module.scss";
import type { SavedColorsCloseConfirmationConfig } from "./requestSavedColorsClose";

export function SavedColorsCloseConfirmationModal(
  props: SavedColorsCloseConfirmationConfig & {
    isOpen: boolean;
  },
) {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onCancel} closeOnBackdropClick={false}>
      <div className={styles.container}>
        <h2>{props.title}</h2>
        <p>{props.message}</p>
        <div className={styles.buttonGroup}>
          <ButtonBar>
            <Button data-testid="confirmation-cancel" onClick={props.onCancel}>
              {props.cancelLabel}
            </Button>
            <Button data-testid="confirmation-yes" onClick={props.onConfirm} styleRemove>
              {props.confirmLabel}
            </Button>
          </ButtonBar>
        </div>
      </div>
    </Modal>
  );
}
